import { ApiResponse } from "@/api/api.d";
import { api } from "@/api/api";
import {
  CalcIntlTransferRequest,
  CalcIntlTransferResponse,
  ConfirmInternationalTransferRequest,
  ConfirmInternationalTransferResponse,
  InitInternationalTransferRequest,
  InitInternationalTransferResponse,
  InitConfirmInternationalTransferRequest,
  InitConfirmInternationalTransferResponse,
  InternationalTransferMasterDataResponse,
  IntlTransferPurposeResponse,
  ValidateSwiftRequest,
  ValidateSwiftResponse,
  SupplementIntlTransferDocumentRequest,
  SupplementIntlTransferDocumentResponse,
} from "@/dto/international-transfer/international-transfer";

const BASE_URL = "/transfer-service/rest/web/request";
const CATEGORY_CODE = "INTERNATIONAL_TRANSFER";
// Danh mục mục đích chuyển tiền quốc tế lấy từ customer-service (API thật).
const CUSTOMER_SERVICE_URL = "/customer-service/rest/app/request";
const PURPOSE_CATEGORY_CODE = "CORP_TRANS_TRANSFER_TO_ACCOUNT";

const internationalTransferAPI = api.injectEndpoints({
  endpoints: (builder) => ({
    getInternationalTransferMasterData: builder.query<
      ApiResponse<InternationalTransferMasterDataResponse>,
      void
    >({
      query: () => ({
        url: BASE_URL,
        method: "POST",
        functionName: "getInternationalTransferMasterData",
        categoryCode: CATEGORY_CODE,
      }),
    }),
    // Danh mục mục đích chuyển tiền quốc tế (nhóm + chi tiết) — function getIntlTransferPurpose.
    getIntlTransferPurpose: builder.query<
      ApiResponse<IntlTransferPurposeResponse>,
      void
    >({
      query: () => ({
        url: CUSTOMER_SERVICE_URL,
        method: "POST",
        functionName: "getIntlTransferPurpose",
        categoryCode: PURPOSE_CATEGORY_CODE,
      }),
    }),
    makerInitInternationalTransfer: builder.mutation<
      ApiResponse<InitInternationalTransferResponse>,
      InitInternationalTransferRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "makerInitInternationalTransfer",
        categoryCode: CATEGORY_CODE,
        data,
      }),
    }),
    // Init bước xác nhận — gọi khi bấm "Xác nhận" trước khi mở modal OTP
    // (bám cấu trúc initBatchTransfer của chuyển tiền theo lô).
    initConfirmInternationalTransfer: builder.mutation<
      ApiResponse<InitConfirmInternationalTransferResponse>,
      InitConfirmInternationalTransferRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "initConfirmInternationalTransfer",
        categoryCode: CATEGORY_CODE,
        data,
      }),
    }),
    makerConfirmInternationalTransfer: builder.mutation<
      ApiResponse<ConfirmInternationalTransferResponse>,
      ConfirmInternationalTransferRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "makerConfirmInternationalTransfer",
        categoryCode: CATEGORY_CODE,
        data,
      }),
    }),
    calcIntlTransfer: builder.mutation<
      ApiResponse<CalcIntlTransferResponse>,
      CalcIntlTransferRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "calcIntlTransfer",
        categoryCode: CATEGORY_CODE,
        data,
      }),
    }),
    validateSwift: builder.mutation<
      ApiResponse<ValidateSwiftResponse>,
      ValidateSwiftRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "validateSwift",
        categoryCode: CATEGORY_CODE,
        data,
      }),
    }),
    // Bổ sung chứng từ cho GD CTQT đã gửi duyệt (SRS KB-27, wire BE JVC-3373).
    supplementIntlTransferDocument: builder.mutation<
      ApiResponse<SupplementIntlTransferDocumentResponse>,
      SupplementIntlTransferDocumentRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "supplementInternationalTransferDocument",
        categoryCode: CATEGORY_CODE,
        data,
      }),
      invalidatesTags: (_r, _e, arg) => [
        { type: "getTransactionDetail", id: arg.transId },
      ],
    }),
  }),
});

export const {
  useGetInternationalTransferMasterDataQuery,
  useGetIntlTransferPurposeQuery,
  useMakerInitInternationalTransferMutation,
  useInitConfirmInternationalTransferMutation,
  useMakerConfirmInternationalTransferMutation,
  useCalcIntlTransferMutation,
  useValidateSwiftMutation,
  useSupplementIntlTransferDocumentMutation,
} = internationalTransferAPI;

export default internationalTransferAPI;
